module.exports = __webpack_public_path__ + "static/media/map.bc984ba9.png";